








































































































import Vue from 'vue'
import Api from '@/api'
import { getModule } from 'vuex-module-decorators'
import { PaymentsModule } from '@/store/modules/payments.module'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import ReviewSidebar from './components/ReviewSidebar.vue'
import ReviewActions from './components/ReviewActions.vue'
import ReviewInfo from './components/ReviewInfo.vue'
import ReviewPaymentMethod from './components/ReviewPaymentMethod.vue'
import ReviewApplied from './components/ReviewApplied.vue'
import SuccessMessage from './components/SuccessMessage.vue'
import { EAutoPayItemStatus, ESchedulePaymentItemType, EUserPermissions, IAutoPayItem } from '@zunta/configurations'
import { NoCache } from '@/decorators/NoCache'
import Card from '@/components/Card.vue'
import GoBack from '@/components/GoBack.vue'
import StatusAutoPaymentItem from '@/components/statuses/StatusAutoPaymentItem.vue'
import AddressesPopup from '@/views/app/management/components/AddressesPopup.vue'
import { User } from '@/classes/User'

@Component({
  components: {
    AddressesPopup,
    StatusAutoPaymentItem,
    GoBack,
    ReviewActions,
    ReviewSidebar,
    ReviewApplied,
    ReviewInfo,
    ReviewPaymentMethod,
    Icon,
    SuccessMessage,
    Card
  }
})
export default class PaymentsReview extends Vue {
  user: User = Api.getUser() as User
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)
  ESchedulePaymentItemType: any = ESchedulePaymentItemType
  EAutoPayItemStatus: any = EAutoPayItemStatus
  resolvedPaymentId: number | null = null
  EUserPermissions: any = EUserPermissions

  showAddressPopup: boolean = false
  isLoading: boolean = false
  isSuccess: boolean = false

  @NoCache
  get section () {
    return this.$route.params.section
  }

  get scheduleSettingStatistics () {
    return this.$store.state.payments.scheduleSettingStatistics
  }

  @NoCache
  get scheduleItemId () {
    return this.$route.params.scheduleItemId ? this.$route.params.scheduleItemId : ''
  }

  get scheduleItems () {
    if (this.section === 'upcoming') {
      return this.$store.state.payments.autoPayItems.filter((item: IAutoPayItem) => {
        return item.status === EAutoPayItemStatus.UPCOMING
      })
    }
    return this.$store.state.payments.autoPayItems.filter((item: IAutoPayItem) => {
      return item.status !== EAutoPayItemStatus.UPCOMING
    })
  }

  get selectedScheduleItem () {
    if (!this.scheduleItemId) {
      return null
    }
    return this.scheduleItems.find((item: IAutoPayItem) => item.id.toString() === this.scheduleItemId.toString())
  }

  get currentReviewNumber () {
    return this.scheduleItems.findIndex((item: IAutoPayItem) => (
      item.id === parseInt(this.scheduleItemId, 10)
    )) + 1
  }

  @NoCache
  get selectedScheduleItemIndex () {
    return this.getSectionScheduleData(this.section).indexOf(this.selectedScheduleItem)
  }

  get getNextData () {
    const nextSection: any = {
      'todo': 'needs-review',
      'needs-review': 'declined',
      'declined': 'todo'
    }
    const scheduleItems = this.getSectionScheduleData(this.section)
    const secondScheduleItems = this.getSectionScheduleData(nextSection[this.section])

    if (this.selectedScheduleItemIndex + 1 < scheduleItems.length) {
      return `${this.section}.${scheduleItems[this.selectedScheduleItemIndex + 1].id.toString()}`
    }

    if (secondScheduleItems.length === 0) {
      return `${this.section}.no-items}`
    }

    return `${nextSection[this.section]}.${secondScheduleItems[0].id.toString()}`
  }

  get isNextAvailable () {
    return this.selectedScheduleItemIndex + 1 < this.getSectionScheduleData(this.section).length
  }

  get isPrevAvailable () {
    return this.selectedScheduleItemIndex !== 0
  }

  async mounted () {
    await this.loadData()
    this.$watch('$route', this.loadAdditionalData)
  }

  async loadAdditionalData () {
    if (!this.selectedScheduleItem || !this.selectedScheduleItem.setting) {
      return
    }
    try {
      this.$eventBus.$emit('loading:enable', { message: 'Loading' })
      this.isLoading = true
      await Api.payments.runAutoPayForSetting(this.selectedScheduleItem.setting.id)
      // await this.paymentsModuleInstance.fetchAutoPayItem(this.selectedScheduleItemFromList.id)
      await Promise.all([
        this.fetchStatistics(),
        this.fetchTransactions()
      ])
    } finally {
      this.$nextTick(() => {
        this.$eventBus.$emit('loading:disable')
        this.isLoading = false
      })
    }
  }

  async loadData () {
    try {
      this.$eventBus.$emit('loading:enable', { message: 'Loading' })
      this.isLoading = true
      await this.paymentsModuleInstance.fetchChainAutoPayItemsByFilters({
        statuses: [
          EAutoPayItemStatus.NEEDS_REVIEW,
          EAutoPayItemStatus.DECLINED,
          EAutoPayItemStatus.UPCOMING
        ],
        forReview: true
      })
      const scheduleItem = this.getSectionScheduleData(this.section)[0]
      const routeParams = {
        name: 'management-payments-review',
        params: {
          section: this.section,
          scheduleItemId: 'no-items'
        }
      }
      if (!this.scheduleItemId && scheduleItem) {
        routeParams.params.scheduleItemId = scheduleItem.id.toString()
        await this.$router.push(routeParams)
        return
      } else if (!scheduleItem) {
        await this.$router.push(routeParams)
        return
      } else {
        await Api.payments.runAutoPayForSetting(this.selectedScheduleItem.setting.id)
        // await this.paymentsModuleInstance.fetchAutoPayItem(this.selectedScheduleItemFromList.id)
        await Promise.all([
          this.fetchTransactions(),
          this.fetchStatistics()
        ])
      }
    } finally {
      this.$nextTick(() => {
        this.$eventBus.$emit('loading:disable')
        this.isLoading = false
      })
    }
  }

  async fetchTransactions () {
    if (this.selectedScheduleItem) {
      await this.paymentsModuleInstance.getScheduleItemTransactionsForApply(this.selectedScheduleItem.id)
    }
  }

  async fetchStatistics () {
    if (this.selectedScheduleItem) {
      await this.paymentsModuleInstance.fetchScheduleSettingStatistics(this.selectedScheduleItem.setting.id)
    }
  }

  getSectionScheduleData (section: string) {
    const sectionNames: any = {
      'needs-review': EAutoPayItemStatus.NEEDS_REVIEW,
      'declined': EAutoPayItemStatus.DECLINED,
      'upcoming': EAutoPayItemStatus.UPCOMING,
      'todo': 'todo'
    }

    if (!sectionNames[section]) {
      return []
    }

    return sectionNames[section] === 'todo'
      ? this.scheduleItems.filter((item: IAutoPayItem) => item.status !== EAutoPayItemStatus.UPCOMING)
      : this.scheduleItems.filter((item: IAutoPayItem) => item.status === sectionNames[section])
  }

  closeSuccessMessage () {
    this.isSuccess = false
    this.$router.push({
      name: 'management-payments'
    })
  }

  async goNext () {
    const nextSection: any = {
      'all': 'needs-review',
      'needs-review': 'declined',
      'declined': 'all'
    }

    const scheduleItems = this.getSectionScheduleData(this.section)
    const secondScheduleItems = this.getSectionScheduleData(nextSection[this.section])
    let params = null

    if (this.selectedScheduleItemIndex + 1 < scheduleItems.length) {
      params = {
        section: this.section,
        scheduleItemId: scheduleItems[this.selectedScheduleItemIndex + 1].id.toString()
      }
    } else if (secondScheduleItems.length > 0) {
      params = {
        section: nextSection[this.section],
        scheduleItemId: secondScheduleItems[0].id.toString()
      }
    }

    if (params) {
      await this.$router.push({
        name: 'management-payments-review',
        params: params
      })
    }
  }

  async goPrev () {
    const scheduleItems = this.getSectionScheduleData(this.section)
    if (this.isPrevAvailable) {
      await this.$router.push({
        name: 'management-payments-review',
        params: {
          section: this.section,
          scheduleItemId: scheduleItems[this.selectedScheduleItemIndex - 1].id.toString()
        }
      })
    }
  }

  goToResident (options: any) {
    this.$locationManager.openNewTab(this.$router.resolve(options).href)
  }

  async onApprove (res: any) {
    if (res && res.payment && res.payment.id && res.status !== 'Failed') {
      if (this.selectedScheduleItem && this.selectedScheduleItem.setting && this.selectedScheduleItem.setting.receiptTo && this.selectedScheduleItem.setting.receiptTo.length) {
        const emailAddresses: string = this.selectedScheduleItem.setting.receiptTo.map((item: any) => item.email).join(', ')
        this.$eventBus.$emit('notify', {
          color: 'var(--status-success-color)',
          message: `A receipt has been sent to the following email addresses: ${emailAddresses}`,
          header: 'Receipt has been sent',
          icon: 'warning'
        })
        await this.goNext()
        return
      }
      this.resolvedPaymentId = res.payment.id
      this.showAddressPopup = true
    }
  }
}
